import * as PATHS from '@/constants/paths';
import { client, queryClient } from '@/graphql/client';
import { Error404 } from '@/pages/404';
import { EmptyResourcePage } from '@/pages/EmptyResource/EmptyResourcePage';
import { ProjectPage } from '@/pages/ProjectPage/ProjectPage';
import { jotaiStore } from '@/stores/jotaiStore';
import { config } from '@/utils/split';
import { ApolloProvider } from '@apollo/client';
import { ToastRoot, TooltipProvider } from '@skand/ui';
import { SplitFactory } from '@splitsoftware/splitio-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'jotai';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ExplorePage } from '../pages/ExplorePage';
import { DownloaderV2 } from './DownloaderV2/DownloaderV2';
import { PrivateRoute } from './PrivateRoute';

export const Main = () => {
  return (
    <ApolloProvider client={client}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Switch>
            <Route path={`${PATHS.ERROR_404}/:errorCode?`}>
              <Error404 />
            </Route>
            <Route path={`${PATHS.EMPTY_RESOURCE}/:resourceType`}>
              <EmptyResourcePage />
            </Route>

            <PrivateRoute fallback={PATHS.ROOT}>
              <Route path={PATHS.PROJECT_ROOT}>
                <ProjectPage />
              </Route>

              <Route path={PATHS.EXPLORE_ROOT}>
                <ExplorePage />
              </Route>

              <Route path={PATHS.EXPLORE_BETA_COMPAT}>
                <ExplorePage />
              </Route>
            </PrivateRoute>
          </Switch>
        </BrowserRouter>
      </QueryClientProvider>
    </ApolloProvider>
  );
};

export const Root = () => {
  return (
    <Provider store={jotaiStore}>
      <div className="relative h-full w-full flex">
        <TooltipProvider delayDuration={300} skipDelayDuration={100}>
          <SplitFactory config={config}>
            <Main />
          </SplitFactory>
          <DownloaderV2 />
          <ToastRoot className="z-901 ml-18px" size="l" />
        </TooltipProvider>
      </div>
    </Provider>
  );
};
